export default {
  language(state) {
    const lang = state.language ?? 'en'
    return lang.split('-')[0] // Removing dialect
  },

  getTheme(state) {
    return state.theme
  },

  currency(state) {
    return state.currency
  },

  anonymousTracking(state) {
    return state.enableAnonymousTracking
  },

  implementError(state) {
    return state.implementError
  },
}
